"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MainStore from 'Stores/MainStore';
import TopBar from 'Components/TopBar';
import SideDrawer from './SideDrawer/SideDrawer';
import classNames from 'classnames';
import Form from './Forms/Form';
import { System } from "Constants/objects";

var styles = function styles(theme) {
  return {
    appFrame: {
      zIndex: 1,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      height: '100%',
      flexGrow: 1
    },
    content: {
      overflow: 'hidden',
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: 0
    },
    'contentShift-left': {
      marginLeft: 0
    },
    'contentShift-right': {
      marginRight: 0
    },
    drawerHeader: {
      height: '45px',
      minHeight: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px'
    }
  };
};

var Main =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Main, _React$Component);

  function Main(props) {
    var _this;

    _classCallCheck(this, Main);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Main).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = MainStore.getList();
    return _this;
  }

  _createClass(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      MainStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      MainStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(MainStore.getList());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          drawerWidth = _this$props.drawerWidth,
          drawerAnchor = _this$props.drawerAnchor,
          drawerOpen = _this$props.drawerOpen;
      var before = null,
          after = null;
      if (drawerAnchor === System.DIRECTION.LEFT) before = React.createElement(SideDrawer, {
        drawerWidth: drawerWidth,
        drawerAnchor: drawerAnchor,
        drawerOpen: drawerOpen
      });else after = React.createElement(SideDrawer, {
        drawerWidth: drawerWidth,
        drawerAnchor: drawerAnchor,
        drawerOpen: drawerOpen
      });
      return React.createElement("div", {
        className: classes.appFrame
      }, React.createElement(TopBar, {
        drawerWidth: drawerWidth,
        drawerAnchor: drawerAnchor,
        drawerOpen: drawerOpen
      }), React.createElement("div", {
        id: "before-main-content"
      }, before), React.createElement("main", {
        className: classNames(classes.content, classes["contentShift-".concat(drawerAnchor)]),
        id: "main-content"
      }, React.createElement("div", {
        className: classes.drawerHeader
      }), React.createElement(Form, null)), React.createElement("div", {
        id: "after-main-content"
      }, after));
    }
  }]);

  return Main;
}(React.Component);

_defineProperty(Main, "propTypes", {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  drawerWidth: PropTypes.number.isRequired
});

export default withStyles(styles, {
  withTheme: true
})(Main);